export const selectAttendanceStatus = (state) =>
  state.status.attendanceStatus;

export const selectAttendanceStatusLoading = (state) =>
  state.status.loading;

export const selectAttendanceStatusError = (state) =>
  state.status.error;

export const selectAttendanceStatusMeta = (state) => 
  state.status.meta;

export const selectAttendanceStatusById = (state) =>
  state.status.selectStatus;